<template>
  <div class="row">
    <div class="col-lg-6 col-xl-6 col-sm-12 mb-5">
      <dashboard-box :title="$t('bulk_point_actions.id_list')">
        <template v-slot:toolbar>
          <b-form-radio-group
              id="btn-radios-2"
              v-model="id_type"
              :options="id_types"
              buttons
              button-variant="outline-primary"
              size="sm"
              name="radio-btn-outline"
          ></b-form-radio-group>
        </template>
        <template v-slot:preview>
          <prism-editor
              class="my-editor"
              v-model="code"
              :highlight="highlighter"
              :line-numbers="lineNumbers"
          ></prism-editor>
        </template>
      </dashboard-box>
    </div>
    <div class="col-lg-6 col-xl-6 col-sm-12 mb-5">
      <dashboard-box :title="$t('bulk_point_actions.bulk_action')">
        <template v-slot:toolbar>
          <b-button size="sm" v-if="delivery_cart" v-b-modal.delivery_carts class="mr-2"><i class="mr-2 fas fa-search"></i> {{$t('bulk_point_actions.delivery_carts')}}</b-button>
          <b-modal :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" size="lg" id="delivery_carts" :title="$t('bulk_point_actions.delivery_carts')">
            <b-row>
              <b-col sm="10">
                <b-form-group>
                  <b-form-input
                      size="sm"
                      type="text"
                      class="form-control form-control-solid"
                      required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-button size="sm"> {{$t('general.refresh')}}</b-button>
              </b-col>
              <b-col sm="12">
                <data-table
                    :items="table.items"
                    :fields="report.fields"
                    :paginate="report.paginate"
                    page.sync="3"
                    perPage.sync="10"
                ></data-table>
              </b-col>
            </b-row>
          </b-modal>

          <b-button size="sm" v-b-modal.action_history variant="secondary"><i class="fas fa-history mr-1"></i> {{$t('bulk_point_actions.action_history')}}</b-button>
          <b-modal ok-only :cancel-title="$t('general.cancel')" :ok-title="$t('general.close')" size="xl" id="action_history" :title="$t('bulk_point_actions.action_history')">
            <b-row>
              <b-col md="3">
                <b-form-group label="Başlangıç Tarihi">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="date"
                      size="sm"
                      required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Bitiş Tarihi">
                  <b-form-input
                      class="form-control form-control-solid"
                      type="date"
                      size="sm"
                      required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label="Kullanıcı Seç">
                  <b-form-select v-model="selected_user" :options="users" size="sm" class="form-control form-control-solid"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-button size="sm" variant="primary" class="mt-8">{{$t('general.search')}}</b-button>
              </b-col>
              <b-col sm="12">
                <data-table
                    :items="table.action_history_items"
                    :fields="report.action_history_fields"
                    :paginate="report.paginate"
                    page.sync="3"
                    perPage.sync="10"
                ></data-table>
              </b-col>
            </b-row>
          </b-modal>

        </template>
        <template v-slot:preview>
          <b-form-group
              :label="$t('bulk_point_actions.point_action')"
              :description="$t('bulk_point_actions.point_action_desc')"
          >
            <b-form-select
                class="form-control form-control-solid"
                @change="changeIt($event,'actions')"
                v-model="form.action"
                :options="actions"></b-form-select>
          </b-form-group>
          <b-form-group :label="$t('general.desc')">
            <b-form-input
                v-model="form.name"
                type="text"
                class="form-control form-control-solid"
                required
            ></b-form-input>
          </b-form-group>
          <b-form-group :label="$t('bulk_point_actions.point')">
            <b-form-input
                v-model="form.point"
                type="number"
                class="form-control form-control-solid"
                required
            ></b-form-input>
          </b-form-group>
        </template>
        <template v-slot:foot>
          <b-button @click="submit" class="fa-pull-right"><i class="mr-2 fas fa-save"></i> {{$t('bulk_point_actions.submit')}}</b-button>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { PrismEditor } from "vue-prism-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css"; // import syntax highlighting styles
import Swal from "sweetalert2";

export default {
  name: "BulkPointActions",
  components: { DataTable, DashboardBox,PrismEditor },
  methods: {
    highlighter(code) {
      return highlight(code, languages.js,'html'); //returns html
    },
    changeIt(data,input) {
      if (data == "Anket Puan Yükleme"){
        this.delivery_cart = true;
      }else{
        this.delivery_cart = false;
      }
    },
    submit(){
      Swal.fire({
        title: "",
        text: "Puanlar başarıyla yüklendi.",
        icon: "success",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText: "Tamam"
      });
    }

  },
  data() {
    return {
      form : {
        action : null,
        name : '',
        point : 1

      },
      id_types : ['Voter ID', 'Member ID'],
      id_type : 'Member ID',
      code: '153486\n' +
          '247138\n' +
          '341568\n' +
          '355491\n',
      lineNumbers: true,
      actions:  [{text : this.$t('general.select'), value : null}, 'Yönetici Puan Ekleme','Yönetici Puan Düşme', 'Anket Puan Yükleme', 'Kampanya Puan Yükleme', 'Anket Puan Yükleme Screenout'],
      delivery_cart : false,
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'radio', label: '', sortable: false},
          {key: 'delivery_type', label: 'Gönderim Tipi', sortable: false},
          {key: 'name', label: 'Kart Adı', sortable: true},
          {key: 'created_at', label: 'Oluşturulma Tarihi', sortable: true},
        ],
        action_history_fields: [
          {key: 'created_at', label: 'İşlem Tarihi', sortable: true},
          {key: 'user', label: 'İşlemi Yapan', sortable: false},
          {key: 'type', label: 'İşlem Türü', sortable: true},
          {key: 'point', label: 'Puan', sortable: true},
          {key: 'member_id', label: 'Member ID', sortable: true},
          {key: 'user_info', label: 'Üye', sortable: true},
        ],
      },
      table : {
        items : [
          {'delivery_type' : 'SRV', 'name' : '12951 - Getir', 'created_at' : '4.01.2021 19:40'},
          {'delivery_type' : 'SRV', 'name' : '12951 - Getir 10', 'created_at' : '4.01.2021 19:40'},
          {'delivery_type' : 'SRV', 'name' : '12951 - Getir 9', 'created_at' : '4.01.2021 19:40'},
          {'delivery_type' : 'SRV', 'name' : '12951 - Dominos Tracking Araştırması', 'created_at' : '4.01.2021 19:40'},
          {'delivery_type' : 'SRV', 'name' : '12951 - Bakliyat Marka Sağlığı 4', 'created_at' : '4.01.2021 19:40'},
          {'delivery_type' : 'SRV', 'name' : '12951 - Bakliyat Marka Sağlığı 3', 'created_at' : '4.01.2021 19:40'},
          {'delivery_type' : 'SRV', 'name' : '12951 - Banking Advices Online 5', 'created_at' : '4.01.2021 19:40'},
          {'delivery_type' : 'SRV', 'name' : '12951 - Banking Advices Online 4', 'created_at' : '4.01.2021 19:40'},
          {'delivery_type' : 'SRV', 'name' : '12951 - Banking Advices Online 3', 'created_at' : '4.01.2021 19:40'},
          {'delivery_type' : 'SRV', 'name' : '12951 - Boya Kullanım Alışkanlıkları Araştırması', 'created_at' : '4.01.2021 19:40'},
        ],
        action_history_items : [
          {'created_at' : '4.01.2021 19:40', 'user' : 'Emre Yıldız', 'type' : 'Yönetici Puan Ekleme', 'point' : '1000', 'member_id' : '1481768', 'user_info' : 'Erhan Tez'},
          {'created_at' : '4.01.2021 19:40', 'user' : 'Ali Kaya', 'type' : 'Yönetici Puan Düşme', 'point' : '300', 'member_id' : '1481768', 'user_info' : 'Burcu Duyan'},
          {'created_at' : '4.01.2021 19:40', 'user' : 'Ayşe Duran', 'type' : 'Yönetici Kupa Ekleme', 'point' : '10', 'member_id' : '1481768', 'user_info' : 'Melis Demir'},
          {'created_at' : '4.01.2021 19:40', 'user' : 'Emre Yıldız', 'type' : 'Yönetici Puan Ekleme', 'point' : '1000', 'member_id' : '1481768', 'user_info' : 'Burhan Kara'},
          {'created_at' : '4.01.2021 19:40', 'user' : 'Ali Kaya', 'type' : 'Yönetici Puan Düşme', 'point' : '300', 'member_id' : '1481768', 'user_info' : 'Yaşar Tama'},
          {'created_at' : '4.01.2021 19:40', 'user' : 'Ayşe Duran', 'type' : 'Yönetici Kupa Ekleme', 'point' : '10', 'member_id' : '1481768', 'user_info' : 'Durmuş Kulaç'},
          {'created_at' : '4.01.2021 19:40', 'user' : 'Emre Yıldız', 'type' : 'Yönetici Puan Ekleme', 'point' : '1000', 'member_id' : '1481768', 'user_info' : 'Enes Şahin'},
          {'created_at' : '4.01.2021 19:40', 'user' : 'Ali Kaya', 'type' : 'Yönetici Puan Düşme', 'point' : '300', 'member_id' : '1481768', 'user_info' : 'Rukiye Talat'},
          {'created_at' : '4.01.2021 19:40', 'user' : 'Ayşe Duran', 'type' : 'Yönetici Kupa Ekleme', 'point' : '10', 'member_id' : '1481768', 'user_info' : 'Yasin Ata Duru'},
          {'created_at' : '4.01.2021 19:40', 'user' : 'Emre Yıldız', 'type' : 'Yönetici Puan Ekleme', 'point' : '1000', 'member_id' : '1481768', 'user_info' : 'Erhan Tez'},
          {'created_at' : '4.01.2021 19:40', 'user' : 'Ali Kaya', 'type' : 'Yönetici Puan Düşme', 'point' : '300', 'member_id' : '1481768', 'user_info' : 'Burcu Duyan'},
          {'created_at' : '4.01.2021 19:40', 'user' : 'Ayşe Duran', 'type' : 'Yönetici Kupa Ekleme', 'point' : '10', 'member_id' : '1481768', 'user_info' : 'Melis Demir'},
        ],
      },
      selected_user : null,
      users : [{text : this.$t('general.select'), value : null},'Emre Yıldız', 'Ali Kaya', 'Ayşe Duran']
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_2') },
      { title: this.$t('menu.bulk_point_actions') }
    ]);
  }
}
</script>

<style lang="scss">
.my-editor {
  background: #e7e9f1;
  color: #ccc;
  height: 450px;

  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

.prism-editor__textarea:focus {
  outline: none;
}

.height-300 {
  height: 300px;
}
</style>
